import { render, staticRenderFns } from "./TestAdminModal.vue?vue&type=template&id=7809140a&"
import script from "./TestAdminModal.vue?vue&type=script&lang=js&"
export * from "./TestAdminModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports